<template>
  <div class="row mt-6">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h5>
            <i class="fe fe-credit-card"></i>
            <strong>{{ transactions.length }} Transactions </strong>
          </h5>
        </div>
        <div class="table-responsive">
          <table class="table align-td-middle card-body">
            <thead>
              <tr>
                <th>S/N</th>
                <th>Name Type</th>
                <th>Transaction Amount</th>
                <!-- <th>Transaction Proof</th> -->
                <th>Description</th>
                <th>Date Created</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(trx, index) in transactions" v-bind:key="trx.id">
                <td>{{ index + 1 }}</td>
                <td>
                  {{ trx.type }}

                  <span
                    :class="`btn m-b-15 ml-2 mr-2 badge badge-soft-${trx.color}`"
                  >
                    {{ trx.status }}
                  </span>
                </td>
                <td>&#8358;{{ trx.amount | numeral(0, 0) }}</td>
                <!-- <td>
                 
                </td> -->
                <td>{{ trx.description }}</td>
                <td>
                  {{ trx.created_at | moment("dddd, MMMM Do YYYY") }}
                </td>
                <td>
                  <button
                    class="btn btn-outline-info m-1"
                    v-if="trx.type == 'offline'"
                    @click="gotoTrxImage(trx)"
                  >
                    proof
                  </button>

                  <a
                    :href="`/payment/transaction/${trx.id}`"
                    target="blank"
                    class="btn btn-outline-info m-1"
                  >
                    <i class="fe fe-eye"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["transactions"],
  data() {
    return {
      trx_doc: null,
      isLoading: false,
      fullPage: true,
    };
  },

  methods: {
    gotoTrxImage(trx) {
      this.axios
        .get(`/api/v1/auth/get/transaction-document/${trx.id}`)
        .then((response) => {
          console.log(response);
          this.$toasted.success("Gotten Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.trx_doc = response.data.data;
          window.open(this.trx_doc.image_url, "_blank");
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>